"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const react_bootstrap_1 = require("react-bootstrap");
const react_1 = __importDefault(require("react"));
function FormText(props) {
    return (react_1.default.createElement(react_bootstrap_1.FormGroup, null,
        react_1.default.createElement(Form_1.default.Label, { className: "label" }, props.label),
        react_1.default.createElement(Form_1.default.Control, { type: props.type, disabled: props.disabled, placeholder: props.placeholder, name: props.name, value: props.value ? props.value : "", className: "br-10", onChange: props.onChange, maxLength: props.maxLength }),
        props.note && react_1.default.createElement(Form_1.default.Text, { muted: true }, props.note),
        props.error && react_1.default.createElement(Form_1.default.Text, { muted: true, className: "color-red" }, props.error),
        props.html && react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: props.html } })));
}
exports.default = FormText;
